var map = {
	"./add.png": "cae3",
	"./aspn_icon/date_picker/arrow_left.png": "7616",
	"./aspn_icon/date_picker/arrow_left_dark.png": "4ba4",
	"./aspn_icon/date_picker/arrow_left_standing.png": "515d",
	"./aspn_icon/date_picker/arrow_left_standing_dark.png": "97f0",
	"./aspn_icon/date_picker/arrow_left_web.png": "7d1d",
	"./aspn_icon/date_picker/arrow_left_web_dark.png": "f2e3",
	"./aspn_icon/date_picker/arrow_right.png": "378b",
	"./aspn_icon/date_picker/arrow_right_dark.png": "9418",
	"./aspn_icon/date_picker/arrow_right_standing.png": "bc41",
	"./aspn_icon/date_picker/arrow_right_standing_dark.png": "9f2b",
	"./aspn_icon/date_picker/arrow_right_web.png": "e5da",
	"./aspn_icon/date_picker/arrow_right_web_dark.png": "5423",
	"./aspn_icon/date_picker/calender.png": "90e9",
	"./aspn_icon/date_picker/calender_circle.png": "8c32",
	"./aspn_icon/date_picker/calender_circle_dark.png": "85bf",
	"./aspn_icon/date_picker/calender_dark.png": "7d01",
	"./aspn_icon/download/icon_android.png": "963a",
	"./aspn_icon/download/icon_android_dark.png": "8601",
	"./aspn_icon/download/icon_apple.png": "7f2c",
	"./aspn_icon/download/icon_apple_dark.png": "7b53",
	"./aspn_icon/download/icon_qr.png": "2666",
	"./aspn_icon/download/icon_qr_dark.png": "bab1",
	"./aspn_icon/estimated_probability/2.png": "b4af",
	"./aspn_icon/estimated_probability/2_dark.png": "dc2f",
	"./aspn_icon/highlights/icon_highlights.png": "df23",
	"./aspn_icon/highlights/icon_highlights_dark.png": "e4db",
	"./aspn_icon/highlights/icon_highlights_dark_selected.png": "bebd",
	"./aspn_icon/highlights/icon_highlights_selected.png": "59c0",
	"./aspn_icon/icon_avatar.png": "80f9",
	"./aspn_icon/icon_avatar_dark.png": "9bcf",
	"./aspn_icon/icon_avatar_menu.png": "daa6",
	"./aspn_icon/icon_close.png": "ebcc",
	"./aspn_icon/icon_favourite.png": "fdd0",
	"./aspn_icon/icon_favourite_dark.png": "ee9b",
	"./aspn_icon/icon_favourite_disabled.png": "01e9",
	"./aspn_icon/icon_favourite_footer.png": "5bc7",
	"./aspn_icon/icon_favourite_footer_selected.png": "0328",
	"./aspn_icon/icon_favourite_footer_selected_dark.png": "4032",
	"./aspn_icon/icon_favourite_selected.png": "ea4d",
	"./aspn_icon/icon_favourite_web.png": "2c0c",
	"./aspn_icon/icon_favourite_web_disabled.png": "49f2",
	"./aspn_icon/icon_favourite_web_selected.png": "6571",
	"./aspn_icon/icon_fb.png": "b1cf",
	"./aspn_icon/icon_ig.png": "f5c2",
	"./aspn_icon/icon_language.png": "fc2f",
	"./aspn_icon/icon_live.png": "d3e5",
	"./aspn_icon/icon_live_selected.png": "f634",
	"./aspn_icon/icon_mail.png": "81ec",
	"./aspn_icon/icon_more.png": "d2bf",
	"./aspn_icon/icon_more_dark.png": "7530",
	"./aspn_icon/icon_more_selected.png": "4895",
	"./aspn_icon/icon_more_selected_dark.png": "80a1",
	"./aspn_icon/icon_news.png": "81b1",
	"./aspn_icon/icon_news_dark.png": "1b5b",
	"./aspn_icon/icon_news_selected.png": "f02f",
	"./aspn_icon/icon_news_selected_dark.png": "74f0",
	"./aspn_icon/icon_score.png": "263a",
	"./aspn_icon/icon_score_dark.png": "fec3",
	"./aspn_icon/icon_score_selected.png": "5c29",
	"./aspn_icon/icon_score_selected_dark.png": "0f27",
	"./aspn_icon/icon_search.png": "66be",
	"./aspn_icon/icon_search_filter_webapp.png": "1906",
	"./aspn_icon/icon_search_filter_webapp_dark.png": "b43d",
	"./aspn_icon/icon_search_webapp.png": "1943",
	"./aspn_icon/icon_search_webapp_dark.png": "b26c",
	"./aspn_icon/language/language_hover.png": "4145",
	"./aspn_icon/live/web_live_selected.png": "e24d",
	"./aspn_icon/live/webapp_live_selected.png": "0dd1",
	"./aspn_icon/logo/logo-dark.png": "bb45",
	"./aspn_icon/logo/logo-light.png": "ebdd",
	"./aspn_icon/logo/logo.png": "6d3f",
	"./aspn_icon/match_info/football.png": "c6c9",
	"./aspn_icon/match_info/football_dark.png": "e572",
	"./aspn_icon/match_info/football_dark_webapp.png": "c52c",
	"./aspn_icon/match_info/football_webapp.png": "fc2d",
	"./aspn_icon/match_info/match_icon_1.png": "4c74",
	"./aspn_icon/match_info/match_icon_1_dark.png": "592c",
	"./aspn_icon/match_info/match_icon_2.png": "0ea6",
	"./aspn_icon/match_info/match_icon_2_dark.png": "1109",
	"./aspn_icon/match_info/match_icon_3.png": "a076",
	"./aspn_icon/match_info/match_icon_3_dark.png": "b7d8",
	"./aspn_icon/player/icon_ball.png": "274b",
	"./aspn_icon/player/icon_ball_mobile.png": "d2d6",
	"./aspn_icon/player/icon_fav.png": "9fe95",
	"./aspn_icon/player/icon_fav_mobile_selected.png": "9edb",
	"./aspn_icon/player/icon_fav_selected.png": "7a63",
	"./aspn_icon/player/icon_match_field.png": "43e4",
	"./aspn_icon/player/icon_match_field_mobile.png": "e732",
	"./aspn_icon/player/news_ads_mobile_1.png": "f17c",
	"./aspn_icon/player/news_ads_mobile_2.png": "e31a",
	"./aspn_icon/player/player.png": "709d",
	"./aspn_icon/player/player_bg.png": "0673",
	"./aspn_icon/player/player_bg2.png": "5967",
	"./aspn_icon/player/player_not_found.png": "e93c",
	"./aspn_icon/player/player_not_found_gray_bg.png": "dfd1",
	"./aspn_icon/player/player_stats_bg.png": "90ba",
	"./aspn_icon/social_media/icon_favourite.png": "5057",
	"./aspn_icon/social_media/icon_favourite_dark.png": "ac25",
	"./aspn_icon/social_media/icon_favourite_disabled.png": "f0d7",
	"./aspn_icon/social_media/icon_favourite_disabled_dark.png": "4df2",
	"./aspn_icon/social_media/icon_favourite_selected.png": "4cc3",
	"./aspn_icon/social_media/icon_favourite_selected_dark.png": "a5a5",
	"./aspn_icon/social_media/icon_share.png": "92f4",
	"./aspn_icon/social_media/icon_share_dark.png": "8a5f",
	"./aspn_icon/team/all_competition.png": "5fcb",
	"./aspn_icon/team/all_competition_dark.png": "1106",
	"./fav/icon_fav_web.png": "ffcf",
	"./fav/icon_fav_web_dark.png": "a9a4",
	"./fav/icon_fav_web_dark_disabled.png": "b6ce",
	"./fav/icon_fav_web_dark_hover.png": "ea63",
	"./fav/icon_fav_web_dark_selected.png": "c4c5",
	"./fav/icon_fav_web_disabled.png": "6ff5",
	"./fav/icon_fav_web_hover.png": "2e06",
	"./fav/icon_fav_web_selected.png": "8aa9",
	"./icon-footer-basketball.png": "13be",
	"./icon-footer-close.png": "e1af",
	"./icon-hkfc.png": "4a35",
	"./icon-search-grey.png": "a091",
	"./icon-star-grey.png": "92ae",
	"./icon_android.png": "fbf8",
	"./icon_apple.png": "8d9f",
	"./icon_arrow_down_black.png": "ceea",
	"./icon_arrow_down_white.png": "e725",
	"./icon_arrow_left.png": "3568",
	"./icon_arrow_left_double_white.png": "bae8",
	"./icon_arrow_left_white.png": "8ab2",
	"./icon_arrow_left_white_m.png": "611a",
	"./icon_arrow_right.png": "623e",
	"./icon_arrow_right_double_white.png": "5108",
	"./icon_arrow_right_white.png": "3d22",
	"./icon_avatar_default.png": "255e",
	"./icon_bracket.png": "4311",
	"./icon_bracket_back.png": "f1a9",
	"./icon_bracket_default.png": "4df9",
	"./icon_bracket_hover.png": "0ee3",
	"./icon_bracket_transparent.png": "3652",
	"./icon_calendar.png": "f663",
	"./icon_calendar_selected.png": "895d",
	"./icon_cancel_circle.png": "21ee",
	"./icon_close.png": "46c7",
	"./icon_close_grey.png": "96d6",
	"./icon_close_pwd.png": "6591",
	"./icon_close_white.png": "6869",
	"./icon_cog.png": "9e2e",
	"./icon_cog_active.png": "5d59",
	"./icon_comment_sent.png": "5a65",
	"./icon_comment_sent_colored.png": "0ded",
	"./icon_fav_selected.png": "a9c8",
	"./icon_fav_unselect.png": "100d",
	"./icon_fb.png": "8ff8",
	"./icon_filter.png": "ed35",
	"./icon_filter_float.png": "439d",
	"./icon_filter_selected.png": "af98",
	"./icon_filter_tick_selected.png": "8d5e",
	"./icon_filter_tick_unselect.png": "1dad",
	"./icon_filter_tick_white_selected.png": "1cda",
	"./icon_flag_empty.png": "a946",
	"./icon_flag_england.png": "f584",
	"./icon_football.png": "f6a0",
	"./icon_footer_basketball.png": "fb5e",
	"./icon_footer_close.png": "e83a",
	"./icon_footer_event_selected.png": "7a1b",
	"./icon_footer_event_unselect.png": "9a98",
	"./icon_footer_fantacy_1_selected.png": "dcb7",
	"./icon_footer_fantacy_1_unselect.png": "ee5e",
	"./icon_footer_fantasy_selected.png": "1178",
	"./icon_footer_fantasy_unselect.png": "ee9b3",
	"./icon_footer_fav_selected.png": "cc7f",
	"./icon_footer_fav_unselect.png": "7ca9",
	"./icon_footer_fifa.png": "0750",
	"./icon_footer_fifa_selected.png": "f659",
	"./icon_footer_fifa_unselect.png": "f787",
	"./icon_footer_football.png": "0036",
	"./icon_footer_highlights_selected.png": "ffe1",
	"./icon_footer_highlights_unselect.png": "bcf1",
	"./icon_footer_hkfs_selected.png": "3ae5",
	"./icon_footer_hkfs_unselect.png": "54783",
	"./icon_footer_home_selected.png": "c19e",
	"./icon_footer_home_unselect.png": "2c74",
	"./icon_footer_more_unselect.png": "4a21",
	"./icon_footer_news_selected.png": "59a6",
	"./icon_footer_news_unselect.png": "ffd3",
	"./icon_footer_notification_unselect.png": "ce52",
	"./icon_footer_refresh.png": "67ea",
	"./icon_footer_sport_basketball_selected.png": "4c91",
	"./icon_footer_sport_football_selected.png": "803e",
	"./icon_goal_player.png": "d16c",
	"./icon_google_play.png": "3ee6",
	"./icon_h2h_alert.png": "2652",
	"./icon_highlight.png": "9af6",
	"./icon_highlight_detail.png": "8bf0",
	"./icon_highlight_mobile_header.png": "9e26",
	"./icon_highlight_selected.png": "07cc",
	"./icon_ig.png": "3547",
	"./icon_line.png": "97ce",
	"./icon_live_video_disabled.png": "77cf",
	"./icon_livevideo.png": "7428",
	"./icon_love_orange.png": "f8bf",
	"./icon_love_orange_selected.png": "98ba",
	"./icon_love_orrange.png": "e8a5",
	"./icon_mail.png": "1f2b",
	"./icon_match.png": "f412",
	"./icon_match_real_time_stats.png": "8a8d",
	"./icon_match_real_time_stats_selected.png": "2436",
	"./icon_match_tracker.png": "4d8a",
	"./icon_match_tracker_disabled.png": "844e",
	"./icon_match_tracker_selected.png": "18f2",
	"./icon_more.png": "f6bc",
	"./icon_news_author.png": "5a94",
	"./icon_notification_basketball.png": "5874",
	"./icon_notification_empty.png": "a0ad",
	"./icon_notification_football.png": "c8d1",
	"./icon_notification_grey.png": "1a2db",
	"./icon_notification_new.png": "acd2",
	"./icon_notification_selected.png": "fb11",
	"./icon_pencil.png": "4445",
	"./icon_play.png": "30c2",
	"./icon_play168.png": "77ce",
	"./icon_refresh.png": "adfb",
	"./icon_reply.png": "2d64",
	"./icon_search.png": "2f37",
	"./icon_show_pwd.png": "c8ec",
	"./icon_star.png": "5602",
	"./icon_star_black_solid.png": "7fdf",
	"./icon_star_blue_solid.png": "d478",
	"./icon_star_grey_hollow.png": "9fe5",
	"./icon_star_grey_hollow_mobile.png": "a51b",
	"./icon_star_light_blue_solid_small.png": "a08b",
	"./icon_star_selected.png": "a527",
	"./icon_star_white.png": "ec9b",
	"./icon_star_white_hollow.png": "b2cc",
	"./icon_star_white_solid_small.png": "2c4c",
	"./icon_star_yellow_solid.png": "9c07",
	"./icon_star_yellow_solid_mobile.png": "b210",
	"./icon_substitube_arrow_down.png": "9fe9",
	"./icon_substitube_arrow_up.png": "93bf",
	"./icon_team.png": "fd9f",
	"./icon_tick_green_selected.png": "14fe",
	"./icon_tick_selected.png": "ff41",
	"./icon_tick_unselect.png": "1fa5",
	"./icon_tick_white_disabled.png": "3081",
	"./icon_tick_white_selected.png": "22670",
	"./icon_tick_white_unselect.png": "2d98",
	"./icon_tiktok.png": "7508",
	"./icon_tiktok_black.png": "120d",
	"./icon_toastr_error_red.png": "1f22",
	"./icon_toastr_fav_added.png": "2bf4",
	"./icon_toastr_fav_removed.png": "1910",
	"./icon_toastr_selected.png": "7215",
	"./icon_twitter.png": "d809",
	"./icon_video_play.png": "1fab",
	"./icon_white_chevron_default_right.png": "0080",
	"./league_icon/english-premier-league-36.png": "4177",
	"./league_icon/english-premier-league-36__dark.png": "35e2",
	"./league_icon/france-ligue-1-11.png": "4370",
	"./league_icon/france-ligue-1-11__dark.png": "1eea",
	"./league_icon/german-bundesliga-8.png": "3d60",
	"./league_icon/german-bundesliga-8__dark.png": "69d5",
	"./league_icon/holland-eredivisie-16.png": "9f79",
	"./league_icon/holland-eredivisie-16__dark.png": "f54c",
	"./league_icon/italian-serie-a-34.png": "c3a5",
	"./league_icon/italian-serie-a-34__dark.png": "f27c",
	"./league_icon/liga-portugal-1-23.png": "9534",
	"./league_icon/liga-portugal-1-23__dark.png": "9823",
	"./league_icon/saudi-professional-league-292.png": "d35a",
	"./league_icon/saudi-professional-league-292__dark.png": "4bad",
	"./league_icon/spanish-la-liga-31.png": "ecd3",
	"./league_icon/spanish-la-liga-31__dark.png": "f63a",
	"./league_icon/uefa-champions-league-103.png": "af81",
	"./league_icon/uefa-champions-league-103__dark.png": "8670",
	"./league_icon/uefa-europa-league-113.png": "f09b",
	"./league_icon/uefa-europa-league-113__dark.png": "23a5",
	"./league_icon/uefa-nations-league-1864.png": "813c",
	"./league_icon/uefa-nations-league-1864__dark.png": "57b5",
	"./rectangle.png": "6033",
	"./social_media/icon_fb.png": "1b00",
	"./social_media/icon_fb_dark.png": "1570",
	"./social_media/icon_line.png": "7100",
	"./social_media/icon_line_colored.png": "f21a",
	"./social_media/icon_line_dark.png": "2b4a",
	"./social_media/icon_share.png": "0001",
	"./social_media/icon_share_dark.png": "0f15",
	"./social_media/icon_social_media_share.png": "693a",
	"./social_media/icon_twitter.png": "970b",
	"./social_media/icon_twitter_dark.png": "245c",
	"./social_media/icon_zalo_colored.png": "bcc6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bac4";